/* global axios */
import ApiClient from './ApiClient';

class VoipDevicesAPI extends ApiClient {
  constructor() {
    super('voip_devices', { accountScoped: true });
  }

  // Re-registra webhook de chamadas na instância WAHA (útil se auto-register
  // no create falhou ou se admin trocou config do WAHA).
  registerWebhook(deviceId) {
    return axios.post(`${this.url}/${deviceId}/register_webhook`);
  }

  // Onboarding StackZap (contrato v650): browser nunca fala com StackZap.
  provision(payload = {}) {
    return axios.post(`${this.url}/provision`, payload);
  }

  connect(deviceId) {
    return axios.post(`${this.url}/${deviceId}/connect`);
  }

  // PNG binário (image/png) — não JSON/base64.
  qrCode(deviceId) {
    return axios.get(`${this.url}/${deviceId}/qr_code`, {
      responseType: 'blob',
    });
  }

  providerStatus(deviceId) {
    return axios.get(`${this.url}/${deviceId}/provider_status`);
  }

  reconnect(deviceId) {
    return axios.post(`${this.url}/${deviceId}/reconnect`);
  }

  disconnect(deviceId) {
    return axios.post(`${this.url}/${deviceId}/disconnect`);
  }

  testConnection(deviceId) {
    return axios.post(`${this.url}/${deviceId}/test_connection`);
  }
}

export default new VoipDevicesAPI();
